module.exports = __webpack_public_path__ + "static/img/pay_qrpay_alipay2@3x.949fec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_alipay2@3x.png
// module id = 5jve
// module chunks = 1